import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IPassport } from '@obvious.tech/constellation'

export const Passport = defineEntity('Passport', {
  endpoint: 'authentication/api/Passport',
  schema: SNoop<IPassport>(),
})
